export default __webpack_public_path__ + "static/media/minnesota.4c21ed6d.jpg";